'use client';
import React, { useState } from 'react';
import Select from './select';
import { useTranslation } from 'react-i18next';
import RoomSelector from './roomselector';
import Traveldate from './traveldate';
import { getDateString } from '../../../utils/dateTime';
import FilterIcon from '../../atoms/icons/filter';
import { useEffect, useRef } from 'react';

const FeedFilter = ({ props }) => {
  const { t } = useTranslation('booking');
  const [showFilter, setShowFilter] = useState(true);

  const {
    airport,
    setAirport,
    airports,
    travelType,
    destinations,
    destination,
    setDestination,
    rooms,
    setRooms,
    loadingFilter,
    periods,
    period,
    setPeriod,
    season,
    noOfProposals,
    setUserInteraction,
  } = props;
  const cbRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (cbRef.current) {
        const isSticky = cbRef.current.getBoundingClientRect().top <= 10;
        if (noOfProposals > 0) {
          if (isSticky) {
            setShowFilter(false);
          } else {
            setShowFilter(true);
          }
        }
      } else {
        setShowFilter(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [noOfProposals]);

  const [showRooms, setShowRooms] = useState(false);

  const filterLoad = loadingFilter ? 'animate-pulse' : '';

  const selectBoxClasses =
    'bg-transparent w-full form-select border-0 pt-4 pb-1';

  const getDestinationString = () => {
    let d = t('All destinations');
    if (destination !== '*' && destination !== null) {
      d = destinations
        .flatMap((group) => group.destinations)
        .find((dest) => dest.id === destination)?.name;

      if (!d) {
        d = destinations.find((group) => group.id === destination)?.name;
      }
    }

    return d;
  };

  return (
    <div
      className={` rounded-2xl bg-yellow pt-4 ${
        showFilter ? 'pb-0' : ''
      } pb-4 md:pb-0 lg:pb-4 w-full ${
        noOfProposals > 0 ? 'sticky' : ''
      } lg:top-[5.25rem] top-2 z-20`}
      ref={cbRef}
    >
      <div className={`flex flex-col lg:flex-row px-4 `}>
        <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-0 md:gap-x-4">
          <div
            className={`${
              showFilter ? 'hidden' : 'flex flex-wrap'
            }  md:hidden w-full justify-between lg:mb-0 h-fit`}
          >
            <div className="flex flex-col flex-nowrap justify-between w-full -mb-2">
              <Select
                label={t('Filter')}
                className={` mb-[1px] w-full relative rounded-t-lg ${filterLoad} `}
              >
                <button
                  type="text"
                  id="travelers"
                  className={`w-[90%] bg-transparent border-0 pt-4 pb-1 ml-3 truncate text-sm  text-left pl-0`}
                  onClick={(e) => setShowFilter(true)}
                  readOnly={true}
                >
                  {airports?.find((a) => a.airportId === airport)?.name}
                  {travelType !== 'Hotel' && ' > '}
                  {getDestinationString()}
                  <div className="absolute right-2 top-0 h-full flex items-center">
                    <FilterIcon />
                  </div>
                </button>
              </Select>

              <Select className={`rounded-b-lg w-full relative ${filterLoad}`}>
                <button
                  type="text"
                  id="travelers"
                  className={`w-[90%] bg-transparent border-0 pt-2 pb-2 ml-3 truncate text-sm  text-left pl-0`}
                  onClick={(e) => setShowFilter(true)}
                  readOnly={true}
                >
                  {getDateString(period.out, period.home)},{' '}
                  {rooms.reduce((a, b) => a + b.adults, 0)} {t('adults')}
                  {rooms.reduce((a, b) => a + b.children, 0) > 0
                    ? `, ${rooms.reduce((a, b) => a + b.children, 0)} ${t(
                        'children',
                      )}`
                    : ''}
                </button>
              </Select>
            </div>
          </div>
          <div
            className={`${
              !showFilter
                ? 'hidden'
                : 'flex flex-wrap sm:flex-nowrap w-full sm:flex-row '
            } md:flex md:flex-row md:flex-nowrap h-fit justify-between items-stretch content-stretch sm:mr-2`}
          >
            <Select
              label={t('From')}
              className={`${
                travelType === 'Hotel' ? 'hidden' : ''
              } rounded-t-lg sm:rounded-r-none sm:rounded-l-lg mb-[1px] sm:mb-auto pb-0 sm:mr-[1px] w-full sm:w-1/2 relative ${filterLoad}`}
            >
              <select
                id="From"
                className={`${selectBoxClasses} `}
                onChange={(e) => {
                  setAirport(e.target.value);
                  setUserInteraction(true);
                }}
                value={airport}
              >
                {airports &&
                  airports.map((airport) => (
                    <option key={airport.id} value={airport.airportId}>
                      {airport.name}
                    </option>
                  ))}
              </select>
            </Select>
            <Select
              label={t('To')}
              className={`  w-full ${
                travelType === 'Hotel'
                  ? 'rounded-lg sm:w-full sm:rounded-lg'
                  : 'rounded-b-lg sm:w-1/2 sm:rounded-l-none sm:rounded-r-lg'
              } relative ${filterLoad}`}
            >
              <select
                id="To"
                className={`${selectBoxClasses} ${
                  travelType === 'Hotel' ? 'w-full' : 'w-full'
                } `}
                onChange={(e) => {
                  setDestination(e.target.value);
                  setUserInteraction(true);
                }}
                value={destination}
                disabled={travelType === 'Flight'}
                readOnly={travelType === 'Flight'}
              >
                <option value={'*'}>{t('All destinations')}</option>
                {destinations &&
                  destinations.map((group) => (
                    <>
                      <option
                        key={group.id}
                        label={group.name}
                        value={group.id}
                        style={{ fontWeight: 'bolder' }}
                      >
                        {group.name}
                      </option>
                      {group.destinations.map((dest) => (
                        <option key={dest.id} value={dest.id}>
                          &nbsp;{dest.name}
                        </option>
                      ))}
                    </>
                  ))}
              </select>
            </Select>
          </div>
          <div
            className={`${
              !showFilter ? 'hidden ' : 'flex '
            } md:flex flex-wrap md:flex-nowrap w-full justify-between lg:mb-0 h-fit`}
          >
            <div className="flex flex-wrap xs:flex-nowrap justify-between w-full ">
              <Select
                label={t('Travelers')}
                className={`rounded-lg w-full relative ${filterLoad}`}
              >
                <button
                  type="text"
                  id="travelers"
                  className={`w-full bg-transparent border-0 pt-4 pb-1 ml-3 truncate  text-left pl-0`}
                  onClick={(e) => setShowRooms(true)}
                  readOnly={true}
                >
                  {travelType !== 'Flight' && `${rooms.length} ${t('rooms')}, `}
                  {rooms.reduce((a, b) => a + b.adults, 0)} {t('adults')}
                  {rooms.reduce((a, b) => a + b.children, 0) > 0
                    ? `, ${rooms.reduce((a, b) => a + b.children, 0)} ${t(
                        'children',
                      )}`
                    : ''}
                </button>
              </Select>
              <RoomSelector
                showRooms={showRooms}
                setShowRooms={setShowRooms}
                selectBoxClasses={selectBoxClasses}
                rooms={rooms}
                setRooms={setRooms}
                setUserInteraction={setUserInteraction}
              />
            </div>
          </div>
          <div
            className={`${
              !showFilter ? 'hidden' : ''
            } flex md:flex flex-wrap md:flex-nowrap w-full justify-between lg:mb-0 h-fit`}
          >
            <div className="flex flex-wrap xs:flex-nowrap justify-between w-full mb-2 lg:mb-0">
              <Traveldate
                props={{
                  periods,
                  period,
                  setPeriod,
                  season,
                  selectBoxClasses,
                  setUserInteraction,
                }}
              />
            </div>
            {/* <div className="flex flex-col flex-nowrap justify-between w-12 h-auto ml-4 -mb-2 ">
              <button
                type="text"
                id="travelers"
                className={`bg-yellow-30 border-0 p-3 truncate text-sm rounded-lg`}
                onClick={(e) => setShowFilter(true)}
                readOnly={true}
              >
                <div className="h-full flex items-center">
                  <FilterIcon />
                </div>
              </button>
               <Select
                className={` mb-[1px] w-full relative rounded-t-lg ${filterLoad} `}
              >

              </Select>
            </div> */}
          </div>
          {/*           <div className="flex flex-col flex-nowrap w-full justify-between w-12 h-auto ml-4 -mb-2 ">
            asdasd
          </div>
 */}{' '}
        </div>
        {noOfProposals > 0}
        <div className={`${showFilter ? 'flex' : 'hidden'}  w-full md:hidden`}>
          <div className="w-full justify-start flex pb-0">
            <button
              className="bg-black text-white rounded-full py-2 px-4 w-full lg:w-auto whitespace-nowrap text-base font-crystalCondensed"
              onClick={() => setShowFilter(false)}
            >
              {t('Close')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedFilter;
